<h3>Qu'est-ce que le Green-score®&nbsp;?</h3>
<p>
  Le <b>Green-score®</b> est un indicateur représentant l'<b>impact environnemental</b> des produits alimentaires. Il classe les produits en 7 catégories de
  l'impact environnemental le plus faible <span class="gs-A-plus">A+</span>, à l'impact le plus élevé <span class="gs-F">F</span>.
</p>

<div class="greenscore">
  <!-- <ion-icon src="/assets/svg/dish/green-score/modal/green-score-fr.svg"></ion-icon> -->
  <img src="/assets/svg/dish/green-score/modal/green-score-fr.png" alt="Green Score" />
</div>

<h3>Comment le Green-score® est-il calculé&nbsp;?</h3>
<p>
  Le <b>Green-score®</b> est développé par des experts indépendants en environnement et porté par un collectif d'acteurs engagés de l'alimentation durable.<br />
  Le <b>Green-score®</b> est calculé à partir de <b>l'impact environnemental</b> d'un plat et ensuite affiné grâce à des <span class="gs-A-plus">BONUS</span> /
  <span class="gs-F">MALUS</span>. Cela permet d'obtenir une note finale sur 100, convertie en une lettre allant de <span class="gs-A-plus">A+</span> à
  <span class="gs-F">F</span>.
</p>
<p>Critères des <span class="gs-A-plus">BONUS</span> / <span class="gs-F">MALUS</span>&nbsp;:</p>
<div class="greenscore-criteria">
  <img src="/assets/svg/dish/green-score/modal/green-score-criteria-fr.png" alt="Critères des BONUS/MALUS" />
</div>

<h3>Quelle est la finalité du Green-score®&nbsp;?</h3>
<p>
  Le <b>Green-score®</b> permet de comparer facilement l'impact environnemental de nos recettes pour faire des <b>choix éclairés</b> en matière
  <b>d'alimentation durable</b>.
</p>

<h3>Où trouver d'autres informations sur le Green-score®&nbsp;?</h3>
<p>
  Si vous souhaitez en savoir plus sur le Green-score®, vous pouvez visiter le site officiel&nbsp;:
  <a href="https://docs.score-environnemental.com" target="_blank">https://docs.score-environnemental.com</a>
</p>
<footer>
  <p>MIEUX COMPRENDRE, C'EST DÉJA AGIR</p>
</footer>
